var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('div',{staticClass:"image",style:(_vm.maxHeight)},[_c('img',{attrs:{"src":_vm.content}})])])}
var staticRenderFns = []

export { render, staticRenderFns }